// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IMyYn","importantInfo":"styles_importantInfo__3ZfP9"};